import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLine, Eyebrow, Reveal, EASE } from "@/components/Reveal";

const ITEMS = [
  { name: "Gastro-Beratung.de", tag: "Hospitality Tech", url: "https://gastro-beratung.de/", text: "Digitalisierungsberatung für Gastronomiebetriebe. Fokus: Kassensysteme, Pay & Order, Prozesse & Support." },
  { name: "ALL CAPS gGmbH", tag: "Culture & Impact", url: "https://all.caps.de/", text: "Kultur- und Subkulturprojekte rund um HipHop, Urban Art, Demokratie & Inklusion. (Tapefabrik & taped!)" },
  { name: "tokenforge", tag: "Web3 / RWA", url: "https://tokenforge.io/", text: "Fintech-Plattform für Web3 & RWA-Tokenisierung u.a. von Immobilien und Energieprojekten." },
  { name: "Splitsheet.de", tag: "Musikrechte", url: "https://splitsheet.de/", text: "Rechtssichere Vereinbarung von Musikrechten, einfach und unkompliziert." },
];

const Card = ({ item, i }) => (
  <motion.a
    href={item.url} target="_blank" rel="noopener noreferrer"
    data-testid={`portfolio-card-${i}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay: (i % 2) * 0.1 }}
    whileHover={{ y: -6 }}
    className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-border/60 bg-card p-8 shadow-[0_2px_20px_-4px_hsl(220_20%_10%/0.08)] transition-[box-shadow,border-color] duration-500 hover:border-border hover:shadow-[0_12px_40px_-8px_hsl(220_20%_10%/0.15)]"
  >
    <span className="absolute inset-x-0 top-0 h-[2px] origin-left scale-x-0 bg-accent transition-transform duration-700 group-hover:scale-x-100" />
    <div className="mb-6 flex items-center justify-between">
      <span className="text-xs font-medium tracking-wide text-[hsl(var(--accent-ink))]">{item.tag}</span>
      <span className="font-display text-sm text-muted-foreground">0{i + 1}</span>
    </div>
    <h3 className="font-display text-2xl font-medium mb-3 flex items-center gap-2">
      {item.name}
      <ArrowUpRight className="h-5 w-5 text-[hsl(var(--accent-ink))] transition-transform duration-500 md:opacity-0 md:-translate-x-1 md:translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0" />
    </h3>
    <p className="text-muted-foreground text-sm leading-relaxed">{item.text}</p>
  </motion.a>
);

export const Portfolio = () => (
  <section id="portfolio" className="py-24 md:py-36" data-testid="portfolio-section">
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <div className="max-w-3xl mb-16">
        <Reveal><Eyebrow className="mb-8">Portfolio</Eyebrow></Reveal>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
          <MaskLine>Aktuelle Beteiligungen</MaskLine>
          <MaskLine delay={0.12}><span className="italic">und Projekte</span></MaskLine>
        </h2>
      </div>
      <div className="grid gap-6 md:grid-cols-2 auto-rows-fr">
        {ITEMS.map((item, i) => <Card key={item.name} item={item} i={i} />)}
      </div>
    </div>
  </section>
);
